import { render, staticRenderFns } from "./NavItemMobile.vue?vue&type=template&id=75db1182"
import script from "./NavItemMobile.vue?vue&type=script&lang=js"
export * from "./NavItemMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports